module.exports = __webpack_public_path__ + "officialStatic/img/case5.3c624dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case5.png
// module id = /ra0
// module chunks = 0